/* globals jQuery */
import 'fitvids.1.1.0'

import './slideshows.js'
import responsiveNav from './responsive-nav.js'

(($) => {

    const html = document.querySelector('html');
    html.classList.remove('no-js')
    html.classList.add('js');

    // Make nav menu nice & responsive
    const mainNav = document.querySelector('nav.main-nav');
    if( mainNav ){
        responsiveNav(mainNav,{
            navType: 'offCanvas',
            hasSearchInNav: mainNav.dataset.hasSearch === 'true',
            searchDialogSelector: '#searchDialog',
            closeOnOutsideClick: true
        });
    }

    // Responsive Videos
    $('.rtecontent, .video').fitVids();

    //NEWS LANDING FILTER LINK LIST
    const newsFilter = document.getElementById('categoryFilter');
    if( newsFilter ){
        const filterBtn = document.getElementById('category-nav-button');
        const list = document.getElementById('category-nav-list');

        const closeFilterMenu = ({ restoreFocus = false } = {}) => {
            filterBtn.setAttribute('aria-expanded', 'false');
            list.hidden = true;

            if( restoreFocus ){
                filterBtn.focus();
            }
        };

        // 1. Toggle Menu Visibility
        filterBtn.addEventListener('click', () => {
            const isExpanded = filterBtn.getAttribute('aria-expanded') === 'true';
            filterBtn.setAttribute('aria-expanded', !isExpanded);
            list.hidden = isExpanded;
        });

        // 2. Close menu if clicking outside
        document.addEventListener('click', (e) => {
            if (!filterBtn.contains(e.target) && !list.contains(e.target)) {
                closeFilterMenu();
            }
        });

        // 3. Close menu on escape and return focus to trigger button
        document.addEventListener('keydown', (e) => {
            if( e.key !== 'Escape' ) return;

            closeFilterMenu({ restoreFocus: true });
        });

        // 4. Close menu when keyboard focus tabs away from the filter
        newsFilter.addEventListener('focusout', (e) => {
            if( list.hidden ) return;

            const nextFocusedElement = e.relatedTarget;
            if( !nextFocusedElement || !newsFilter.contains(nextFocusedElement) ){
                closeFilterMenu();
            }
        });
    }

    // Pause/play video on .js-pause-video button click
    $('.js-pause-video').on('click', function() {
        const video = $(this).siblings('video')[0];
        if (video) {
            if (video.paused) {
                video.play();
                $(this).attr('aria-pressed', 'true');
                $(this).attr('aria-label', 'Pause video');
            } else {
                video.pause();
                $(this).attr('aria-pressed', 'false');
                $(this).attr('aria-label', 'Unpause video');
            }
            $(this).toggleClass('is-paused');
        }
    });

    // Search dialog controls are centralized here instead of inline onclick handlers.
    const searchDialog = document.getElementById('searchDialog');
    const btnOpenSearch = document.getElementById('btnOpenSearch');
    const btnCloseSearch = document.getElementById('btnCloseSearch');

    if (searchDialog && btnOpenSearch && btnCloseSearch) {
        btnOpenSearch.addEventListener('click', function() {
            searchDialog.showModal();
        });

        btnCloseSearch.addEventListener('click', function() {
            searchDialog.close();
        });

        // Restore focus to opener on any close (Escape, backdrop-click, or programmatic close from nav).
        searchDialog.addEventListener('close', function() {
            btnOpenSearch.focus();
        });
    }

})(jQuery)
